import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagRS = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C11.193 0 0 11.193 0 25c0 3.058.55 5.987 1.555 8.696h46.89A24.945 24.945 0 0 0 50 25C50 11.193 38.807 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0C14.251 0 5.088 6.784 1.555 16.304h46.89C44.913 6.784 35.75 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M6.464 14.131v12.471c0 7.094 9.268 9.268 9.268 9.268s9.267-2.174 9.267-9.268V14.131H6.464Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M10.297 16.305h10.87v-4.348l-2.175 1.087-3.26-3.261-3.261 3.26-2.174-1.086v4.348ZM22.826 28.338l-7.065-7.065-7.065 7.065L11 30.644l4.76-4.76 4.76 4.76 2.305-2.306Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M22.826 21.739H19.53a2.174 2.174 0 1 0-3.797-2.113 2.173 2.173 0 1 0-3.798 2.113h-3.24c0 1.2 1.046 2.174 2.247 2.174h-.072c0 1.2.973 2.174 2.174 2.174 0 1.063.763 1.946 1.771 2.135l-1.713 3.867c.821.334 1.718.52 2.659.52.94 0 1.838-.186 2.659-.52l-1.713-3.867a2.174 2.174 0 0 0 1.771-2.136c1.201 0 2.174-.973 2.174-2.173h-.072c1.2 0 2.246-.974 2.246-2.174Z"
}));
FlagRS.displayName = 'FlagRS';
export default withFlagWrapper(FlagRS);
//# sourceMappingURL=index.js.map